import { render, staticRenderFns } from "./PortfolioEmptyLink.vue?vue&type=template&id=1da1be0a&scoped=true&"
import script from "./PortfolioEmptyLink.vue?vue&type=script&lang=js&"
export * from "./PortfolioEmptyLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da1be0a",
  null
  
)

export default component.exports